import {listGateways} from 'instruments/instrument-gateways/InstrumentGatewayDAO';
import {OptionData} from 'ui-library/menus/MenuConstants';

export function getConnectionGatewayMenuOptionDatas(): Promise<Array<OptionData>> {
  return listGateways().then(({gateways}) =>
    gateways.map((gateway) => ({
      name: gateway.name,
      value: gateway.id,
    }))
  );
}
